<template>
  <div class="page flex-col">
    <div class="select_container flex-row">
      <SearchInput
        class="select_item"
        placeholder="搜索班级"
        @search="handleSearch"
        @input="handleInputChange"
      />

      <Dropdown
        class="select_item"
        :options="academicOptions"
        placeholder="学年"
        @selection-change="handleYearSelection"
      />
    </div>

    <div class="info flex-row">
      <span class="text_info">{{ total }}个班级</span>
    </div>

    <div class="list_container">
      <DataTable
        :headers="tableHeaders"
        :items="loopData"
        show-pagination="true"
        :total="total"
        :pageSize="pageSize"
        :currentPage="currentPage"
        @item-click="handleItemClick"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue"
import { useRouter } from "vue-router"
import { useStore } from "vuex"

import Dropdown from "@/components/teacher/Dropdown.vue"
import SearchInput from "@/components/teacher/SearchInput.vue"
import DataTable from "@/components/teacher/DataTable.vue"
import alovaInstance from "@/utils/alova"

const router = useRouter()
const store = useStore()
const tableHeaders = [
  {
    key: "academicYear",
    label: "学年",
    style: "width: 8vw;",
    cellStyle: "width: 14vw;",
  },
  {
    key: "classId",
    label: "班级（ID）",
    style: "width: 14vw;",
    cellStyle: "width: 10vw;text-align: left;margin-left: 2.8vw;",
  },
  {
    key: "className",
    label: "班级（名称）",
    style: "width: 17.1vw;",
    cellStyle: "width: 40vw;text-align: left;margin-left: 6vw;",
  },
  {
    key: "studentCount",
    label: "人数",
    style: "width: 35.7vw;",
    cellStyle: "width: 10vw;text-align: left;margin-left: 0.75vw;",
  },
]
// const academicOptions = ref(["2024-2025"])
// const loopData = ref([
//   {
//     academicYear: "2024-2025",
//     classId: "S1A",
//     className: "初一（1）班",
//     studentCount: 3,
//   },
// ])
const className = ref("")
const academicYear = ref("")
const academicOptions = ref([])
const loopData = ref([])
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)

onMounted(async () => {
  try {
    const response = await alovaInstance.Post("/Class/GetAllAcademic")
    // console.log(response)
    if (response.code === 1000) {
      academicOptions.value = response.data
    } else {
      alert("获取数据失败：" + response.message)
    }

    handleSelection()
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
})

const handleSearch = (value) => {
  // console.log("Search class:", value)
  className.value = value
  handleSelection()
}

const handleInputChange = (value) => {
  // console.log("Input changed:", value)
  className.value = value
  handleSelection()
}

const handleYearSelection = (year) => {
  // console.log("Selected year:", year)
  academicYear.value = year
  handleSelection()
}

const handleSelection = async () => {
  const lists = await alovaInstance.Post("/Class/GetClassByFilterCondition", {
    className: className.value,
    academicYear: academicYear.value,
    pageIndex: currentPage.value,
    pageSize: pageSize.value,
  })
  // console.log(lists)
  if (lists.code === 1000 && lists.data != null) {
    loopData.value = lists.data.classInfoList
    // loopData.value = loopData.value.concat(loopData.value).concat(loopData.value)
    total.value = lists.data.totalCount
  } else if (lists.code === 1000 && lists.data == null) {
    loopData.value = []
    total.value = 0
    alert("没有符合条件的班级")
  } else {
    alert("获取数据失败：" + lists.message)
  }
}

const handleItemClick = (item) => {
  store.dispatch("setCurrentClass", item)
  router.push({
    path: "/teacher/class",
  })
}

const handlePageChange = (page) => {
  currentPage.value = page
  handleSelection()
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
}

.select_container,
.info {
  width: auto;
  height: auto;
  margin: 0;
}

.select_item {
  margin: 0.89vw 0 0 1.25vw;
}

.text_info {
  width: 3.75vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.36vw;
  margin: 0.89vw 0 0 1.25vw;
}

.list_container {
  position: relative;
  width: 80.68vw;
  height: 38vw;
  margin-left: 1.25vw;
  margin-top: 0.6vw;
}
</style>
